import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, NumberDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { StamhoofdFilterDecoder } from '../filters/FilteredRequest.js';
export class ChargeRequest extends AutoEncoder {
    description;
    price;
    amount;
    dueAt = null;
    createdAt = null;
    filter = null;
}
__decorate([
    field({ decoder: StringDecoder })
], ChargeRequest.prototype, "description", void 0);
__decorate([
    field({ decoder: NumberDecoder })
], ChargeRequest.prototype, "price", void 0);
__decorate([
    field({ decoder: NumberDecoder, nullable: true })
], ChargeRequest.prototype, "amount", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], ChargeRequest.prototype, "dueAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], ChargeRequest.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: StamhoofdFilterDecoder, nullable: true })
], ChargeRequest.prototype, "filter", void 0);
//# sourceMappingURL=ChargeRequest.js.map